
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';

const Container = styled.div`
    background-color: ${props => (props.isDragging ? 'transparent' : props.backgroundColor)}
    width: 100%

`;

class ElementWrapper extends React.PureComponent {
    render() {
        return (
            <div style={{ width: '100%' }} >
                <Draggable draggableId={this.props.id} isDragDisabled={this.props.isDragDisabled} index={this.props.index} >
                    {(provided, snapshot) => (
                        <Container
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            {...this.props}
                            ref={provided.innerRef}
                            isDragging={snapshot.isDragging}
                        >

                            {this.props.children}
                        </Container>
                    )}

                </Draggable>
            </ div>


        )
    }
}
export default ElementWrapper;